export enum CookieKeys {
  publicKey = "publicKey",
  jwt = "jwt",
  password = "password",
}
